"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Menu =
/** @class */
function () {
  function Menu(raw) {
    this.menuId = raw.menuId;
    this.menuName = raw.menuName;
    this.menuNameEN = raw.menuNameEN;
    this.menuDescription = raw.menuDescription;
    this.menuDescriptionEN = raw.menuDescriptionEN;
    this.menuSKUId = raw.menuSKUId;
    this.menuPhoto = raw.menuPhoto;
    this.menuPrice = raw.menuPrice;
    this.isOffline = raw.isOffline;
    this.nextOpenDateTime = raw.nextOpenDateTime;
    this.menuQCStatus = raw.menuQCStatus;
    this.menuRejectReason = raw.menuRejectReason;
    this.tagId = raw.tagId;
  }

  return Menu;
}();

exports.Menu = Menu;